<template>
  <div class="product-detail">
    <!-- 导航栏 -->
    <Navbar />

    <!-- 面包屑导航 -->
    <div class="breadcrumb-container" style="margin-top: 100px;">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">Página Inicial</el-breadcrumb-item>
        <el-breadcrumb-item>Checkout</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div v-if="buyType === 1">
      <div>
        {{ goodsInfo.goods_name }}
        <el-image :src="goodsInfo.image" width="50px" height="50px" fit="fill"/>
      </div>
		  <div v-if="spec_id">
        {{ goodsInfo.name }}
      </div>
      <div>
        {{ goodsInfo.baseprice }}
      </div>
      
      <div>
        <el-input-number v-model="num" :min="1"  label="Quantidade"></el-input-number>
      </div>
    </div>
    <div v-if="buyType === 2">
      <div v-for="(item,index) in list" :key="index">
        <div >
          {{ item.goods_name }}
          <el-image :src="item.goods_image" width="50px" height="50px" fit="fill"/>
        </div>
		  <div v-if="item.spec_name">
        {{ item.spec_name }}
      </div>
      <div>
        {{ item.spec_price }}
      </div>
      <div>
        <el-input-number v-model="item.nums" :min="1" @change="e=>changeCartNum(e,item)"  label="Quantidade"></el-input-number>
      </div>
      </div>
    </div>
    
    <div>
        Total: {{ total_amount }}
      </div>
    <el-button type="primary" @click="createOrder">Criar Pedido</el-button>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { categoryDetail } from '@/api/home'
import { delCart, listCart, switchItem, swtichAll, setCartNum, cartbuy, goodsbuy } from '@/api/cart'
import { createOrder } from '@/api/order'



export default {
  name: 'Settle',
  components: {
    Navbar
  },
  data() {
    return {
      list: [],
      cids: [],
      goods_id: '',
      spec_id: null,
      num: 1,
      goodsInfo: {},

      buyType: 0, //1=goods_buy 2=cart_buy
      checked: 0,
    }
  },
  computed: {
    total_amount(){
      if(this.buyType === 1){
        return (this.goodsInfo.baseprice * this.num).toFixed(2);
      }else if(this.buyType === 2){
        let total = 0;
        this.list.forEach(item=>{
          total += item.spec_price * item.nums;
        })
        return total.toFixed(2);
      }else{
        return '';
      }
    }
  },

  mounted() {
    if(this.$route.query.goods_id){
      this.buyType = 1;
      this.goods_id = this.$route.query.goods_id;
      this.num = this.$route.query.num || 1;
      this.spec_id = this.$route.query.spec_id || null;
      this.goodsBuyFun();
    }else if(this.$route.query.cids){
      this.buyType = 2;
      this.cids = this.$route.query.cids.split(',');
      this.cartBuyFun();
    }
  },
  methods: {
    createOrder(){
      const { cids, buyType, goods_id, spec_id, num } = this;
      const data = {};
      if(buyType == 1){
        data.goods_id = goods_id;
        data.num = num;
        if(spec_id){
          data.spec_id = spec_id;
        }
      }else if(buyType == 2){
        data.cids = cids.join(',');
      }
      createOrder(data).then(res=>{
        //跳转到订单详情
        this.$router.push({
          name: 'OrderDetail',
          query: {
            id: res.data.order_id
          }

        })

      })

    },
    changeCartNum(e,item){
      setCartNum({id: item.id,num: e})
    },
    goToDetail(item){
      this.$router.push({
        path: '/product/' + item.goods_id,
      })
    },
    cartBuyFun(){
      const { cids  } = this;
      cartbuy({cids: cids.join(',')}).then(res=>{
        console.log('res',res)
        this.list = res.data.list || []
      })
    },
    goodsBuyFun(){
      const { goods_id, spec_id, num } = this;
      const data = {
        goods_id,
        num
      }
      if(spec_id){
        data.spec_id = spec_id;
      }
      //商品购买
      goodsbuy(data).then(res=>{
        // this.$message.success('购买成功')
        this.goodsInfo = res.data
        console.log("goods_buy",res)
      })
    },
  }
}
</script>

<style scoped>
.header {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 0;
  margin-bottom: 20px;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
}

.logo h2 {
  margin: 0;
  color: #ff6b6b;
}

.nav-menu {
  border-bottom: none;
}

.auth-buttons {
  display: flex;
  gap: 10px;
}

.breadcrumb-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 20px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.product-images {
  text-align: center;
}

.main-image {
  margin-bottom: 20px;
}

.main-img {
  width: 100%;
  max-width: 400px;
  height: 400px;
  object-fit: cover;
  border-radius: 8px;
}

.thumbnail-list {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.thumbnail {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.3s;
}

.thumbnail.active {
  border-color: #ff6b6b;
}

.thumbnail:hover {
  border-color: #ff6b6b;
}

.product-info {
  padding-left: 20px;
}

.product-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
}

.product-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.price-section {
  margin-bottom: 20px;
}

.current-price {
  font-size: 32px;
  color: #ff6b6b;
  font-weight: bold;
}

.original-price {
  font-size: 18px;
  color: #999;
  text-decoration: line-through;
  margin-left: 15px;
}

.discount {
  background-color: #ff6b6b;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 15px;
}

.product-meta {
  margin-bottom: 30px;
}

.meta-item {
  display: flex;
  margin-bottom: 8px;
}

.label {
  width: 80px;
  color: #666;
}

.value {
  color: #333;
  font-weight: 500;
}

.spec-section {
  margin-bottom: 30px;
}

.spec-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.spec-label {
  width: 80px;
  color: #666;
}

.quantity-section {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.quantity-label {
  width: 80px;
  color: #666;
}

.action-buttons {
  display: flex;
  gap: 15px;
}

.action-buttons .el-button {
  flex: 1;
  height: 50px;
}

.is-favorite {
  color: #ff6b6b;
}

.detail-tabs {
  margin-top: 60px;
}

.detail-content {
  padding: 20px 0;
}

.detail-content h3 {
  color: #333;
  margin-bottom: 15px;
}

.detail-content ul {
  padding-left: 20px;
}

.detail-content li {
  margin-bottom: 8px;
  color: #666;
}

.specs-content {
  padding: 20px 0;
}

.reviews-content {
  padding: 20px 0;
}

.review-summary {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.rating-overview {
  display: flex;
  align-items: center;
  gap: 15px;
}

.rating-score {
  font-size: 36px;
  font-weight: bold;
  color: #ff6b6b;
}

.review-count {
  color: #666;
}

.review-item {
  border-bottom: 1px solid #eee;
  padding: 20px 0;
}

.review-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.reviewer-name {
  font-weight: bold;
  color: #333;
}

.review-date {
  color: #999;
  font-size: 14px;
}

.review-content {
  color: #666;
  line-height: 1.6;
}

.loading {
  text-align: center;
  padding: 100px 0;
}
.active{
  color: blue;
}
</style>